import "./tab-list.scss";
import Icon from "../icon/icon";

const TabList = (props) => {
  const { name, value, options, ...inputProps } = props;

  return (
    <div className="tabs underline">
      <div role="tablist" aria-label={props.name}>
        {props.options &&
          props.options.map((option, i) => (
            <button
              role="tab"
              disabled={option.disabled}
              key={`${props.name}.${option.value}`}
              className="tab"
              type="button"
              aria-selected={props.value === option.value ? "true" : "false"}
              {...option}
              {...inputProps}
              onClick={props.onChange}
            >
              {option.icon && <Icon className="icon-tab" icon={option.icon} />}
              {option.label}
            </button>
          ))}
      </div>
    </div>
  );
};

export default TabList;
